<div class="terms-page">
    <div class="terms-container">
        <h1 style="font-weight: 400;">Terms and Conditions</h1>

        <h4>Definitions</h4>

        <table class="terms-table">
            <tr>
                <td><b>Loan</b></td>
                <td>The instalment credit offered to you as a personal loan.</td>
            </tr>
            <tr>
                <td><b>I/me/my/you</b></td>
                <td>The student or applicant whose details are set out in the Nedbank loan application.</td>
            </tr>
            <tr>
                <td><b>Applicant</b></td>
                <td>The individual (student or guarantor) that will be completing the loan application in accordance
                    with the Nedbank loan application requirements and must have a minimum monthly income of R5 000.
                </td>
            </tr>
            <tr>
                <td><b>Nedbank</b></td>
                <td>Nedbank Limited (registration number 1951/000009/06) (and its successors in title and assigns), with
                    its registered address at 135 Rivonia Campus, 135 Rivonia Road, Sandown, Sandton, 2196.</td>
            </tr>
            <tr>
                <td><b>SmartFunder</b></td>
                <td>SmartFunder Proprietary Limited, a company duly incorporated under the laws of South Africa, under
                    company registration number 2017/401309/07, with its registered address at De Wagenweg Office Park,
                    Block D, AMB, Stellentia Road, Stellenbosch, Western Cape, 7600.</td>
            </tr>
        </table>

        <p><b>Nedbank</b> and <b>SmartFunder</b> (collectively <b>the parties</b>) have partnered to provide qualifying
            applicants with a loan for educational purposes. </p>

        <h4>Declaration and acknowledgement</h4>
        <ul>
            <li>By using this service, I verify that I am registered at the educational institution mentioned in my
                application, and I consent that the parties may share my information between them to facilitate the
                processing of my application and associated processes.
            </li>
            <li>I confirm that the educational institution and qualification that I have selected are registered and
                accredited by the relevant qualification's authority. </li>
            <li>By applying through SmartFunder, I acknowledge that if my Nedbank loan is approved, Nedbank will
                disburse the funds to the applicant's bank account or the educational institution where it is
                applicable.
            </li>
            <li>In instances where the funds are disbursed into the applicant's bank account, the applicant must make
                payment to the educational institution.</li>
            <li>I agree to be contacted by either party through any communication channel in order for them to
                process my application.</li>

        </ul>

    </div>
</div>